// extracted by mini-css-extract-plugin
export var activeDot = "_8o-c";
export var buttonContainer = "_8o-9";
export var channelButton = "_8o-a";
export var clickable = "_8o-d";
export var content = "_8o-0";
export var contentFull = "_8o-2";
export var contentThird = "_8o-1";
export var contentWrapper = "_8o-7";
export var description = "_8o-5";
export var heightShort = "_8o-f";
export var image = "_8o-3";
export var imageContainer = "_8o-4";
export var selectButton = "_8o-e";
export var spinnerContainer = "_8o-b";
export var titleContent = "_8o-8";
export var titleWrapper = "_8o-6";